import React from "react";
import { Link } from "react-router-dom";
import useWaitlistModal from "./useWaitlistModal";
import Header from "./Header";
import Footer from "./Footer";
import WaitlistModal from "./WaitlistModal";
import jidokaLogo from "./assets/jidoka-logo.png";

const CaseStudies = () => {
  const {
    showWaitlistModal,
    formData,
    isSubmitting,
    isSubmitted,
    formError,
    openWaitlistModal,
    closeWaitlistModal,
    handleInputChange,
    handleSubmit,
  } = useWaitlistModal();

  const caseStudies = [
    {
      id: "jidoka-technologies",
      company: "Jidoka Technologies",
      industry: "Manufacturing Automation",
      description:
        "How Jidoka Technologies transformed their sales process and reduced deal cycles by 40%.",
      metrics: ["40% faster deals", "2x win rate", "95% CRM accuracy"],
      logo: jidokaLogo,
    },
  ];

  return (
    <div className="min-h-screen bg-gray-100">
      <Header onOpenWaitlist={openWaitlistModal} />

      <main className="bg-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
          {/* Page Header */}
          <div className="mb-12">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 mb-4">
              Case Studies
            </h1>
            <p className="text-lg text-slate-600 max-w-3xl">
              See how teams are using Jindo to transform their customer
              interactions into actionable intelligence.
            </p>
          </div>

          {/* Case Study Cards */}
          <div className="grid gap-6 sm:grid-cols-1 lg:grid-cols-2">
            {caseStudies.map((study) => (
              <Link
                key={study.id}
                to={`/case-studies/${study.id}`}
                className="block bg-white rounded-2xl border border-slate-200 p-6 sm:p-8 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
              >
                <div className="text-xs font-bold text-jindo-orange uppercase tracking-wider mb-3">
                  {study.industry}
                </div>
                <div className="flex flex-col content-center justify-around mb-3">
                  <div className="h-6 sm:h-8 mb-2 ">
                    <img
                      src={study.logo}
                      alt={study.company}
                      className="h-full *:w-auto object-contain"
                    />
                  </div>
                  <h3 className="text-2xl font-bold text-slate-900">
                    {study.company}
                  </h3>
                </div>
                <p className="text-slate-600 mb-6 leading-relaxed">
                  {study.description}
                </p>

                {/* Metrics */}
                <div className="space-y-2 mb-6">
                  {study.metrics.map((metric, index) => (
                    <div key={index} className="flex items-center gap-2">
                      <div className="w-1.5 h-1.5 rounded-full bg-jindo-orange"></div>
                      <span className="text-sm font-semibold text-slate-700">
                        {metric}
                      </span>
                    </div>
                  ))}
                </div>

                {/* Read More Link */}
                <div className="flex items-center gap-2 text-jindo-orange font-bold text-sm">
                  Read case study
                  <svg
                    className="w-4 h-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </div>
              </Link>
            ))}
          </div>

          {/* CTA Section */}
          <div className="mt-16 bg-white rounded-2xl border border-slate-200 p-8 sm:p-12 text-center">
            <h2 className="text-2xl sm:text-3xl font-black text-slate-900 mb-4">
              Ready to transform your sales process?
            </h2>
            <p className="text-lg text-slate-600 mb-6 max-w-2xl mx-auto">
              Join the waitlist to see how Jindo can help your team.
            </p>
            <button
              onClick={openWaitlistModal}
              className="inline-flex items-center justify-center rounded-full bg-jindo-orange text-white px-8 py-3 font-bold text-base shadow-lg hover:-translate-y-0.5 transition-transform"
            >
              Join the Waitlist
            </button>
          </div>
        </div>
      </main>

      <Footer />

      <WaitlistModal
        showWaitlistModal={showWaitlistModal}
        closeWaitlistModal={closeWaitlistModal}
        formData={formData}
        handleInputChange={handleInputChange}
        handleSubmit={handleSubmit}
        isSubmitting={isSubmitting}
        isSubmitted={isSubmitted}
        formError={formError}
      />
    </div>
  );
};

export default CaseStudies;
